import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { firestore } from '../../../config/firebase';
import { createProduct, updateProduct } from '../../../store/actions/productActions';
import Spinner from '../../UIComponents/Spinner';
import defaultImg from '../../../assets/img/default/carpet.svg';
import axios from 'axios';
import {
    FiChevronLeft,
    FiCheckCircle,
    FiCircle,
    FiGrid
} from 'react-icons/fi';
import './NewProduct.css';
import lang from './lang';
import Swal from 'sweetalert2';

const siteUrl = 'https://api.carpetking.uz';

class NewProduct extends Component {
    state = {
        img: '',
        name: '',
        code: '',
        color: '',
        colorCode: '',
        brand: '',
        piece: 0,
        price: 0,
        width: 0,
        userId: '',
        content: '',
        quality: '',
        category: 'carpet',
        totalSize: 0,
        dimensions: '',
        lengthLong: 0,
        alertNumber: 0,
        factoryPrice: 0,
        totalFactoryPrice: 0,
        merchantPrice: 0,
        totalMerchantPrice: 0,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        fileName: 'Choose a file',
        readOnly: false,
        progress: 0,
        roll: 0,
        rollLength: 0,
        msg: '',
        msgStatus: false,
        msgType: 'success',
        suggestedFields: [],
        steps: {
            stepOne: 'active-step',
            stepTwo: 'inactive-step',
            stepThree: 'inactive-step',
            finalInfo: 'none'
        },
        display: 'none',
    }

    componentDidMount() {
        const { id } = this.props.user;
        if (this.props.user) {
            this.setState({ userId: id });
        }
    }

    // Close alert messages
    alertMessageHandler = () => {
        this.setState({ msgStatus: false });
    }

    // Update input fields
    inputHandler = (event) => {
        event.persist()
        const { name, value, type } = event.target;
        const refs = ['name', 'code', 'quality', 'brand', 'color', 'category', 'width', 'lengthLong', 'piece', 'factoryPrice', 'merchantPrice', 'alertNumber'];
        const indexOfTheRef = refs.indexOf(name);


        // If button is Enter autofocus next input
        if (event.which === 13) {
            if (indexOfTheRef < refs.length - 1) {
                const nextEl = this[refs[indexOfTheRef + 1] + 'Input'];
                nextEl.focus();
            }
        }
        // If img get image name
        if (name === 'img') {
            this.setState({ fileName: value.slice(value.lastIndexOf('\\') + 1) })
        } else {
            const isNumber = type === 'number' ? (parseFloat(value)) : value.toLowerCase();
            this.setState({ [name]: isNumber });
        }

    }

    stepHandler = (e) => {
        e.preventDefault();
        const { code, factoryPrice, lengthLong, merchantPrice, name, piece, steps } = this.state;
        const colorSuccess = '1px solid #56ae59';
        const colorDanger = '1px solid #e02967';

        if (e.target.name === 'stepTwo') {
            if (name.trim() && code.trim()) {
                this.setState({ steps: { ...steps, stepOne: steps.stepOne + ' done', [e.target.name]: 'active-step' } });
                this.nameInput.style.border = colorSuccess;
                this.codeInput.style.border = colorSuccess;
            } else if (!name.trim()) {
                this.nameInput.style.border = colorDanger;
            } else if (!code.trim() && name.trim()) {
                this.nameInput.style.border = colorSuccess;
                this.codeInput.style.border = colorDanger;
            }
        } else if (e.target.name === 'stepThree') {
            if (piece && factoryPrice && merchantPrice && lengthLong) {
                this.setState({ steps: { ...steps, stepTwo: steps.stepTwo + ' done', [e.target.name]: 'active-step' } });
                this.lengthLongInput.style.border = colorSuccess;
                this.pieceInput.style.border = colorSuccess;
                this.merchantPriceInput.style.border = colorSuccess;
                this.factoryPriceInput.style.border = colorSuccess;
            } else if (!lengthLong) {
                this.lengthLongInput.style.border = colorDanger;
            } else if (!piece && lengthLong) {
                this.pieceInput.style.border = colorDanger;
                this.lengthLongInput.style.border = colorSuccess;
            } else if (!factoryPrice) {
                this.factoryPriceInput.style.border = colorDanger;
            } else if (factoryPrice && !merchantPrice) {
                this.merchantPriceInput.style.border = colorDanger;
                this.factoryPriceInput.style.border = colorSuccess;
            }
        } else if (e.target.name === 'stepOne') {
            this.setState({ steps: { ...steps, stepOne: 'active-step', stepTwo: 'inactive-step' } })
        } else if (e.target.name === 'stepTwoBack') {
            this.setState({ steps: { ...steps, stepTwo: 'active-step', stepThree: 'inactive-step' } })
        }
    }
    categoryHandler = (e) => {
        const { name, value } = e.target;
        console.log(value);
        if (value === 'carpet') {
            this.totalSizeInput.style.display = "block";
            this.widthInput.style.display = "block";
            this.setState({ [name]: value, totalSize: this.state.lengthLong * this.state.width });
        } else {
            console.log('Working');

            // this.totalSizeInput.style.display = "none"
            // this.widthInput.style.display = "none"
            this.setState({ [name]: value, totalSize: this.state.lengthLong, width: this.state.width });
        }
    }

    // Add date to the database
    formhandler = (e) => {
        e.preventDefault();
        // Start spinner
        this.setState({ display: 'flex' });
        const { progress, display, msg, msgStatus, msgType, readOnly, fileName, steps, suggestedFields, ...data } = this.state;

        // Check if there is the same item on the database
        const itemExist = this.props.products.filter(item => {
            const name = this.state.name.trim().toLowerCase() === item.name.trim().toLowerCase();
            const code = this.state.code.trim().toLowerCase() === item.code.trim().toLowerCase();
            const quality = this.state.quality.trim().toLowerCase() === item.quality.trim().toLowerCase();
            const brand = this.state.brand.trim().toLowerCase() === item.brand.trim().toLowerCase();
            const color = this.state.color.trim().toLowerCase() === item.color.trim().toLowerCase();
            const width = this.state.width === item.width;
            const lengthLong = this.state.lengthLong === item.lengthLong;

            if (name && code && quality && brand && color && width && lengthLong) {
                return item
            }
        });


        let newProduct = {}
        if (this.state.category !== 'carpet') {
            const forUpdate = itemExist.length > 0 ? { piece: (data.lengthLong * data.piece) + itemExist[0].piece, id: itemExist[0].id, updatedAt: Date.now() } : { piece: data.lengthLong * data.piece };
            newProduct = {
                ...data,
                ...forUpdate,
                roll: data.piece,
                rollLength: data.lengthLong,
                dimensions: data.width + 'x' + data.lengthLong,
                totalSize: data.category !== 'carpet' ? parseFloat(data.lengthLong).toFixed(2) : parseFloat(data.width * data.lengthLong).toFixed(2),
                totalFactoryPrice: data.category !== 'carpet' ? parseFloat(data.lengthLong * data.factoryPrice).toFixed(2) : parseFloat(data.width * data.lengthLong * data.factoryPrice).toFixed(2),
                totalMerchantPrice: data.category !== 'carpet' ? parseFloat(data.lengthLong * data.merchantPrice).toFixed(2) : parseFloat(data.width * data.lengthLong * data.merchantPrice).toFixed(2)
            }
        } else {
            const forUpdate = itemExist.length > 0 ? { piece: data.piece + itemExist[0].piece, id: itemExist[0].id, updatedAt: Date.now() } : {}
            newProduct = {
                ...data,
                ...forUpdate,
                dimensions: data.width + 'x' + data.lengthLong,
                totalSize: data.category !== 'carpet' ? parseFloat(data.lengthLong).toFixed(2) : parseFloat(data.width * data.lengthLong).toFixed(2),
                totalFactoryPrice: data.category !== 'carpet' ? parseFloat(data.lengthLong * data.factoryPrice).toFixed(2) : parseFloat(data.width * data.lengthLong * data.factoryPrice).toFixed(2),
                totalMerchantPrice: data.category !== 'carpet' ? parseFloat(data.lengthLong * data.merchantPrice).toFixed(2) : parseFloat(data.width * data.lengthLong * data.merchantPrice).toFixed(2)
            }
        }

        if (this.fileRef.files[0]) {
            // If there is the item on the database update it
            if (itemExist.length > 0) {
                firestore
                    .collection('users')
                    .doc(this.props.user.id)
                    .collection('products')
                    .doc(itemExist[0].id)
                    .set(newProduct)
                    .then(() => {

                        const formData = new FormData();
                        formData.append('uid', this.props.user.id);
                        formData.append('productId', itemExist[0].id);
                        formData.append('url', itemExist[0].img);
                        formData.append('edit', itemExist[0].img ? true : false);
                        formData.append('img', this.fileRef.files[0]);

                        let url = '';
                        if (process.env.NODE_ENV !== 'development') {
                            url = siteUrl + '/products/img';
                        } else {
                            url = '/products/img';
                        }

                        axios.post(
                            url, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })
                            .then(async (res) => {
                                if (this.state.img) {
                                    await this.setState({ msg: 'Successfully Updated', id: itemExist[0].id, img: res.data.url + '?m=' + new Date().getTime(), display: 'none', msgStatus: true, readOnly: true, steps: { ...steps, stepThree: steps.stepThree + ' done' } });
                                    await this.props.updateProduct({ ...newProduct, id: itemExist[0].id, img: res.data.url + '?m=' + new Date().getTime() });
                                    this.props.history.push({ pathname: '/products/' + itemExist[0].id, state: { newProduct: true } })
                                } else {
                                    await firestore
                                        .collection('users')
                                        .doc(this.props.user.id)
                                        .collection('products')
                                        .doc(itemExist[0].id)
                                        .update({ img: res.data.url });

                                    await this.setState({ msg: 'Successfully Updated', id: itemExist[0].id, msgStatus: true, img: res.data.url + '?m=' + new Date().getTime(), display: 'none', readOnly: true, steps: { ...steps, stepThree: steps.stepThree + ' done' } });
                                    await this.props.updateProduct({ ...newProduct, id: itemExist[0].id, img: res.data.url + '?m=' + new Date().getTime(), display: 'none', });
                                    this.props.history.push({ pathname: '/products/' + itemExist[0].id, state: { newProduct: true } })
                                }


                            })
                            .catch(err => {
                                console.log(err);

                                Swal.fire({
                                    type: 'error',
                                    // title: 'Oops...',
                                    text: 'Something went wrong while saving the image',
                                    showCloseButton: true,
                                });
                                // this.setState({ msg: 'Something went wrong while saving the image', msgStatus: true, msgType: 'danger', display: 'none' });
                            });
                    })
                    .catch(err => {
                        this.setState({ msg: 'Something went wrong while saving data', msgStatus: true, msgType: 'danger', display: 'none' });
                    })
            } else {
                firestore
                    .collection('users')
                    .doc(this.props.user.id)
                    .collection('products')
                    .add(newProduct).then(newDoc => {
                        const formData = new FormData();
                        formData.append('uid', this.props.user.id);
                        formData.append('productId', newDoc.id);
                        formData.append('img', this.fileRef.files[0]);

                        let url = '';
                        if (process.env.NODE_ENV !== 'development') {
                            url = siteUrl + '/products/img';
                        } else {
                            url = '/products/img';
                        }

                        axios.post(
                            url, formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            })
                            .then(async (res) => {
                                await firestore
                                    .collection('users')
                                    .doc(this.props.user.id)
                                    .collection('products')
                                    .doc(newDoc.id)
                                    .update({ img: res.data.url });

                                await this.setState({ msg: 'Successfully created', msgStatus: true, img: res.data.url + '?m=' + new Date().getTime(), display: 'none', readOnly: true, id: newDoc.id, steps: { ...steps, stepThree: steps.stepThree + ' done' } });
                                await this.props.createProduct({ id: newDoc.id, ...newProduct, img: res.data.url });
                                this.props.history.push({ pathname: '/products/' + newDoc.id, state: { newProduct: true } });

                            })
                            .catch(err => {
                                this.setState({ msg: 'Something went wrong while saving the image', msgStatus: true, msgType: 'danger', display: 'none' });
                            })
                    }).catch(err => {
                        this.setState({ msg: 'Something went wrong while saving the image', msgStatus: true, msgType: 'danger', display: 'none' });
                    })
            }


        } else {
            // If there is the same item in the database just update it
            if (itemExist.length > 0) {
                firestore
                    .collection('users')
                    .doc(this.props.user.id)
                    .collection('products')
                    .doc(itemExist[0].id)
                    .update({
                        piece: itemExist[0].piece + this.state.piece,
                        factoryPrice: newProduct.factoryPrice,
                        totalFactoryPrice: newProduct.totalFactoryPrice,
                        merchantPrice: newProduct.merchantPrice,
                        totalMerchantPrice: newProduct.totalMerchantPrice,
                        updatedAt: Date.now(),
                        img: itemExist[0].img
                    })
                    .then(async (doc) => {

                        await this.setState({
                            readOnly: true,
                            steps: { ...steps, stepThree: steps.stepThree + ' done' },
                            msg: { ...this.state.msg, msg: 'Successfully updated', msgStatus: true },
                            display: 'none',
                            id: itemExist[0].id,
                            img: itemExist[0].img
                        });

                        await this.props.updateProduct({
                            ...newProduct,
                            piece: itemExist[0].piece + this.state.piece,
                            factoryPrice: newProduct.factoryPrice,
                            totalFactoryPrice: newProduct.totalFactoryPrice,
                            merchantPrice: newProduct.merchantPrice,
                            totalMerchantPrice: newProduct.totalMerchantPrice,
                            updatedAt: Date.now(),
                            id: itemExist[0].id,
                            img: itemExist[0].img
                        });
                        this.props.history.push({ pathname: '/products/' + itemExist[0].id, state: { newProduct: true } });

                    })
                    .catch(err => {
                        this.setState({ msg: 'Something went wrong while updating the product', msgStatus: true, msgType: 'danger', display: 'none' });
                    })
            } else {
                firestore
                    .collection('users')
                    .doc(this.props.user.id)
                    .collection('products')
                    .add(newProduct)
                    .then(async (newDoc) => {


                        await this.setState({ msg: 'Successfully created', msgStatus: true, display: 'none', readOnly: true, id: newDoc.id, steps: { ...steps, stepThree: steps.stepThree + ' done' } });
                        await this.props.createProduct({ id: newDoc.id, ...newProduct });
                        this.props.history.push('/products/' + newDoc.id)
                    }).catch(err => {
                        this.setState({ msg: err.message, msgStatus: true, display: 'none', });
                    })
            }

        }
    }

    // Autocomplete suggestion for inputs
    itemSuggestionHandler = (value) => {
        const fields = this.props.products.reduce((obj, item) => {
            // If the name does not exist add to the object. Makes it unique
            if (!obj[item[value]]) {
                obj = { ...obj, [item[value]]: true }
            }
            return obj;
        }, {});

        this.setState({ suggestedFields: Object.keys(fields) });
    }


    render() {
        console.log(this.state);

        const { button, form, info, popup } = lang[this.props.user.lang || 'en'];
        return (
            <div className="container mt-5" id="new-product-page">
                <Spinner display={this.state.display} />
                <div className="row bg-white">
                    <div className="col-sm-4 bg-warning rounded img-wrapper">
                        <div className="img-container">
                            <img src={this.state.img || defaultImg} alt="New Product" className="defaultImg" />
                        </div>
                        <div>
                            <h3 className="text-center">{info.title}</h3>
                            <p className="lead">{info.content}</p>
                        </div>
                        <Link to="/products" className="btn btn-dark black-btn"><FiChevronLeft className="arrow-right" /> {info.button} </Link>
                    </div>
                    <div className="col-sm-8 form-wrapper">
                        <div id="step-counter">
                            <div className={`steps-counter ${this.state.steps.stepOne}`}>
                                <FiCheckCircle className="check-icon" />
                                <FiCircle className="circle-icon" />
                            </div>
                            <div className={`steps-counter ${this.state.steps.stepTwo}`}>
                                <FiCheckCircle className="check-icon" />
                                <FiCircle className="circle-icon" />
                            </div>
                        </div>
                        <div className={`steps ${this.state.steps.stepOne}`} >
                            <div className="form-group">
                                <label>{form.name.label}</label>
                                <input
                                    className="form-control"
                                    placeholder={form.name.placeholder}
                                    name="name"
                                    onChange={(event) => this.inputHandler(event)}
                                    onKeyDown={(event) => this.inputHandler(event)}
                                    defaultValue={this.state.name}
                                    readOnly={this.state.readOnly}
                                    ref={(ref) => this.nameInput = ref}
                                    autoFocus
                                    list="productNameList"
                                    onFocus={(value) => this.itemSuggestionHandler('name')}
                                />
                                <datalist id="productNameList">
                                    {
                                        this.state.suggestedFields.map(item => {
                                            return <option value={item} key={item} />
                                        })
                                    }
                                </datalist>
                            </div>
                            <div className="form-group">
                                <label>{form.code.label}</label>
                                <input
                                    className="form-control"
                                    placeholder={form.code.placeholder}
                                    name="code"
                                    onChange={(event) => this.inputHandler(event)}
                                    onKeyDown={(event) => this.inputHandler(event)}
                                    defaultValue={this.state.code}
                                    readOnly={this.state.readOnly}
                                    ref={(ref) => this.codeInput = ref}
                                    list="productCodeList"
                                    onFocus={(value) => this.itemSuggestionHandler('code')}
                                />
                                <datalist id="productCodeList">
                                    {
                                        this.state.suggestedFields.map(item => {
                                            return <option value={item} key={item} />
                                        })
                                    }
                                </datalist>
                            </div>
                            <div className="form-group">
                                <label>{form.quality.label}</label>
                                <input
                                    className="form-control"
                                    placeholder={form.quality.placeholder}
                                    name="quality"
                                    onChange={(event) => this.inputHandler(event)}
                                    onKeyDown={(event) => this.inputHandler(event)}
                                    defaultValue={this.state.quality}
                                    readOnly={this.state.readOnly}
                                    ref={(ref) => this.qualityInput = ref}
                                    list="productQualityList"
                                    onFocus={(value) => this.itemSuggestionHandler('quality')}
                                />
                                <datalist id="productQualityList">
                                    {
                                        this.state.suggestedFields.map(item => {
                                            return <option value={item} key={item} />
                                        })
                                    }
                                </datalist>
                            </div>
                            <div className="form-group">
                                <label>{form.brand.label}</label>
                                <input
                                    className="form-control"
                                    placeholder={form.brand.placeholder}
                                    name="brand"
                                    onChange={(event) => this.inputHandler(event)}
                                    onKeyDown={(event) => this.inputHandler(event)}
                                    defaultValue={this.state.brand}
                                    readOnly={this.state.readOnly}
                                    ref={(ref) => this.brandInput = ref}
                                    list="productBrandList"
                                    onFocus={(value) => this.itemSuggestionHandler('brand')}
                                />
                                <datalist id="productBrandList">
                                    {
                                        this.state.suggestedFields.map(item => {
                                            return <option value={item} key={item} />
                                        })
                                    }
                                </datalist>
                            </div>

                            <div className="form-group">
                                <label>{form.color.label}</label>

                                <div className="w-100 d-flex">

                                    <input
                                        name="color"
                                        className="form-control color-name"
                                        onChange={(event) => this.inputHandler(event)}
                                        onKeyDown={(event) => this.inputHandler(event)}
                                        placeholder={form.color.placeholder}
                                        defaultValue={this.state.color}
                                        ref={ref => this.colorInput = ref}
                                        list="productColorList"
                                        onFocus={(value) => this.itemSuggestionHandler('color')}
                                    />
                                    <datalist id="productColorList">
                                        {
                                            this.state.suggestedFields.map(item => {
                                                return <option value={item} key={item} />
                                            })
                                        }
                                    </datalist>
                                    <div className="d-flex align-items-center justify-content-center w-100">
                                        <input
                                            type="radio"
                                            style={{ background: '#800000' }}
                                            name="colorCode"
                                            className="rounded-btn"
                                            value="#800000"
                                            onChange={(event) => this.inputHandler(event)}
                                        />
                                        <input
                                            type="radio"
                                            style={{ background: "#f5f5dc" }}
                                            name="colorCode"
                                            className="rounded-btn"
                                            value="#f5f5dc"
                                            onChange={(event) => this.inputHandler(event)}
                                        />
                                        <input
                                            type="radio"
                                            style={{ background: "#964b00" }}
                                            name="colorCode"
                                            className="rounded-btn"
                                            value="#964b00"
                                            onChange={(event) => this.inputHandler(event)}
                                        />
                                        <input
                                            type="radio"
                                            style={{ background: "#005e96" }}
                                            name="colorCode"
                                            className="rounded-btn"
                                            value="#005e96"
                                            onChange={(event) => this.inputHandler(event)}
                                        />
                                        <input
                                            type="radio"
                                            style={{ background: "#ffffff" }}
                                            name="colorCode"
                                            className="rounded-btn"
                                            value="#ffffff"
                                            onChange={(event) => this.inputHandler(event)}
                                        />
                                        <input
                                            type="radio"
                                            style={{ background: "#00963e" }}
                                            name="colorCode"
                                            className="rounded-btn"
                                            value="#00963e"
                                            onChange={(event) => this.inputHandler(event)}
                                        />
                                        <input
                                            type="radio"
                                            style={{ background: "#000000" }}
                                            name="colorCode"
                                            className="rounded-btn"
                                            value="#000000"
                                            onChange={(event) => this.inputHandler(event)}
                                        />
                                        {/* <button className="btn rounded-btn" style={{ background: '#ff007f' }}> */}
                                        <input
                                            type="radio"
                                            style={{ background: "#ff007f" }}
                                            name="colorCode"
                                            className="rounded-btn"
                                            value="#ff007f"
                                            onChange={(event) => this.inputHandler(event)}
                                        />

                                        {/* </button> */}
                                    </div>

                                </div>
                            </div>

                            <div className="form-group">
                                <label><FiGrid />{form.category.label}</label>
                                <select
                                    name="category"
                                    className="custom-select"
                                    onChange={(e) => this.categoryHandler(e)}
                                    value={this.state.category}
                                    ref={(ref) => this.categoryInput = ref}
                                >
                                    <option value="carpet">{form.category.options.carpet}</option>
                                    <option value="hallway-runner">{form.category.options.hallway}</option>
                                    <option value="door-mats">{form.category.options.mats}</option>
                                    <option value="other">{form.category.options.others}</option>
                                </select>
                            </div>
                            <div className="text-right mt-4">
                                <button name="stepTwo" className="badge badge-success badge-lg p-2 px-4 badge-pill" onClick={(e) => this.stepHandler(e)}>{form.steps.next} =></button>
                            </div>
                        </div>
                        {/* =========    STEP 2   =========== */}
                        <div className={`steps step-two ${this.state.steps.stepTwo}`} >
                            <div className="row">
                                <div className="col-sm-6 px-1 col-lg-4">
                                    <label>{form.width.label}</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder={form.width.placeholder}
                                        name="width"
                                        min="1"
                                        onChange={(event) => this.inputHandler(event)}
                                        onKeyDown={(event) => this.inputHandler(event)}
                                        defaultValue={this.state.width}
                                        readOnly={this.state.readOnly}
                                        ref={(ref) => this.widthInput = ref}
                                        onInput={(e) => e.target.value = Math.abs(e.target.value)}
                                    />
                                </div>

                                <div className="col-sm-6 px-1 col-lg-4">
                                    <label>{form.length.label}</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder={form.length.placeholder}
                                        name="lengthLong"
                                        min="1"
                                        defaultValue={this.state.lengthLong}
                                        readOnly={this.state.readOnly}
                                        onChange={(event) => this.inputHandler(event)}
                                        onKeyDown={(event) => this.inputHandler(event)}
                                        ref={(ref) => this.lengthLongInput = ref}
                                        onInput={(e) => e.target.value = Math.abs(e.target.value)}
                                    />
                                </div>

                                <div className="col-sm-6 px-1 col-lg-4">
                                    <label>{form.squareMeter.label} - m <sup>2</sup> </label>
                                    <input
                                        type="number"
                                        min="1"
                                        className="form-control"
                                        placeholder={form.squareMeter.placeholder}
                                        name="totalSize"
                                        value={parseFloat(this.state.width * this.state.lengthLong).toFixed(2)}
                                        readOnly
                                        ref={(ref) => this.totalSizeInput = ref}
                                        onInput={(e) => e.target.value = Math.abs(e.target.value)}
                                    />
                                </div>

                                <div className="col-sm-6 px-1 col-lg-4">
                                    <label>{form.quantity.label}</label>
                                    <input
                                        type="number"
                                        min="1"
                                        className="form-control"
                                        name="piece"
                                        placeholder={form.quantity.placeholder}
                                        onChange={(event) => this.inputHandler(event)}
                                        onKeyDown={(event) => this.inputHandler(event)}
                                        defaultValue={this.state.piece}
                                        readOnly={this.state.readOnly}
                                        ref={(ref) => this.pieceInput = ref}
                                        onInput={(e) => e.target.value = Math.abs(e.target.value)}
                                    />
                                </div>
                                {/* ----- IF user is admin show price inputs */}
                                {
                                    this.props.auth.userType === 'admin'
                                    &&
                                    <div className="col-sm-6 px-1 col-lg-4">
                                        <label>{form.basePrice.label}</label>
                                        <input
                                            type="number"
                                            min="1"
                                            className="form-control"
                                            placeholder={form.basePrice.placeholder}
                                            name="factoryPrice"
                                            onChange={(event) => this.inputHandler(event)}
                                            onKeyDown={(event) => this.inputHandler(event)}
                                            defaultValue={this.state.factoryPrice}
                                            readOnly={this.state.readOnly}
                                            ref={(ref) => this.factoryPriceInput = ref}
                                            onInput={(e) => e.target.value = Math.abs(e.target.value)}
                                        />
                                    </div>
                                }
                                {/* ----- IF user is admin show price inputs */}
                                {
                                    this.props.auth.userType === 'admin'
                                    &&
                                    <div className="col-sm-6 px-1 col-lg-4">
                                        <label>{form.salePrice.label}</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            min="1"
                                            name="merchantPrice"
                                            placeholder={form.salePrice.placeholder}
                                            onChange={(event) => this.inputHandler(event)}
                                            onKeyDown={(event) => this.inputHandler(event)}
                                            defaultValue={this.state.merchantPrice}
                                            readOnly={this.state.readOnly}
                                            ref={(ref) => this.merchantPriceInput = ref}
                                            onInput={(e) => e.target.value = Math.abs(e.target.value)}
                                        />
                                    </div>
                                }
                                <div className="col-sm-6 px-1 col-lg-4">
                                    <label>{form.alertNumber.label}</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        min="1"
                                        placeholder={form.alertNumber.label}
                                        name="alertNumber"
                                        onChange={(event) => this.inputHandler(event)}
                                        onKeyDown={(event) => this.inputHandler(event)}
                                        defaultValue={this.state.alertNumber}
                                        readOnly={this.state.readOnly}
                                        ref={(ref) => this.alertNumberInput = ref}
                                        onInput={(e) => e.target.value = Math.abs(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className="form-group d-block mt-3">
                                <textarea
                                    className="form-control"
                                    placeholder={form.info.placeholder}
                                    name="content"
                                    onChange={(event) => this.inputHandler(event)}
                                    onKeyDown={(event) => this.inputHandler(event)}
                                    ref={ref => this.contentInput = ref}
                                    defaultValue={this.state.content}
                                    readOnly={this.state.readOnly}
                                />
                            </div>
                            <div className="input-group mb-3">
                                <div className="custom-file">
                                    <label className="custom-file-label">{this.state.fileName}</label>
                                    <input
                                        type="file"
                                        className="custom-file-input"
                                        name="img"
                                        onChange={(event) => this.inputHandler(event)}
                                        onKeyDown={(event) => this.inputHandler(event)}
                                        ref={(ref) => this.fileRef = ref}
                                        accept="image/*"
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="progress w-100">
                                    <div
                                        className="progress-bar border-primary"
                                        role="progressbar"
                                        aria-valuemin="0"
                                        style={{ width: this.state.progress + '%' }}
                                    >
                                    </div>
                                </div>
                            </div>
                            <div className="text-right mt-4 d-flex">
                                <button name="stepOne" className="badge badge-light p-2 px-4 badge-pill mr-4" onClick={(e) => this.stepHandler(e)}>{form.steps.back}</button>
                                <button className="btn btn-primary ml-auto" onClick={(event) => this.formhandler(event)}>{form.button}</button>
                            </div>
                        </div>
                        <div className="step result-info" style={{ display: this.state.steps.finalInfo, width: '75%', margin: 'auto' }}>
                            <img src={this.state.img || defaultImg} alt={this.state.name} className="img-fluid" />
                            <p className="text-success"><b>{this.state.name}</b> {popup.title}</p>
                            <Link to={`/products/${this.state.id}`} className="btn btn-lg btn-block btn-success">{popup.button}</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        auth: state.auth,
        products: state.products.products
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createProduct: (product) => dispatch(createProduct(product)),
        updateProduct: (product) => dispatch(updateProduct(product))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewProduct));